import React from 'react';

import { PesquisaPublicaCampo } from '../formularios/interfaces/forms';

/**
 * Um campo da pesquisa do associado, nos 5 tipos de pergunta.
 *
 * Compartilhado entre as DUAS telas públicas — o link (`/pesquisa/:token`) e o
 * totem da oficina (`/pesquisa-totem`, ADR 0032): a pergunta é a mesma nos dois
 * canais, e duplicar o markup faria os formulários divergirem em silêncio.
 * Os estilos `pp-*` vêm de `PesquisaPublicaPage.css`, importado pelas páginas.
 */
const CampoDaPesquisa: React.FC<{
  campo: PesquisaPublicaCampo;
  valor: string | string[] | undefined;
  onChange: (valor: string | string[]) => void;
}> = ({ campo, valor, onChange }) => {
  const marcadas = Array.isArray(valor) ? valor : [];

  return (
    <div className="pp-campo">
      <label className="pp-campo-label" htmlFor={`campo-${campo.id}`}>
        {campo.label}
        {campo.required && <span className="pp-obrigatorio"> (obrigatório)</span>}
      </label>

      {campo.type === 'TEXT_SHORT' && (
        <input
          id={`campo-${campo.id}`}
          type="text"
          className="nice-input"
          value={typeof valor === 'string' ? valor : ''}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {campo.type === 'TEXT_LONG' && (
        <textarea
          id={`campo-${campo.id}`}
          className="pp-textarea"
          rows={4}
          value={typeof valor === 'string' ? valor : ''}
          onChange={(e) => onChange(e.target.value)}
        />
      )}

      {campo.type === 'SINGLE_CHOICE' && (
        <div className="pp-opcoes" role="radiogroup" aria-label={campo.label}>
          {campo.options.map((opcao) => (
            <label key={opcao} className="pp-opcao">
              <input
                type="radio"
                name={`campo-${campo.id}`}
                checked={valor === opcao}
                onChange={() => onChange(opcao)}
              />
              <span>{opcao}</span>
            </label>
          ))}
        </div>
      )}

      {campo.type === 'MULTIPLE_CHOICE' && (
        <div className="pp-opcoes">
          {campo.options.map((opcao) => (
            <label key={opcao} className="pp-opcao">
              <input
                type="checkbox"
                checked={marcadas.includes(opcao)}
                onChange={(e) =>
                  onChange(
                    e.target.checked ? [...marcadas, opcao] : marcadas.filter((item) => item !== opcao),
                  )
                }
              />
              <span>{opcao}</span>
            </label>
          ))}
        </div>
      )}

      {campo.type === 'SCALE' && (
        <div className="pp-escala" role="radiogroup" aria-label={campo.label}>
          {Array.from(
            { length: (campo.scaleMax ?? 5) - (campo.scaleMin ?? 1) + 1 },
            (_, i) => (campo.scaleMin ?? 1) + i,
          ).map((nota) => (
            <button
              key={nota}
              type="button"
              className={`pp-nota ${String(nota) === valor ? 'pp-nota--ativa' : ''}`}
              aria-pressed={String(nota) === valor}
              onClick={() => onChange(String(nota))}
            >
              {nota}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CampoDaPesquisa;
